import { Dialog, DialogContent, Grid } from '@mui/material';
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle';

interface IProps {
    showModal: boolean;
    handleClose: () => void;
    text: string;
    title: string;
}

export const PlannerNoteModal = (props: IProps) => {
    return (
        <Dialog open={props.showModal} onClose={props.handleClose} aria-labelledby="form-dialog-title" maxWidth='lg' fullWidth>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.handleClose}>
                {props.title}
            </CustomDialogTitle>
            <DialogContent style={{ overflow: "hidden" }}>
                <Grid container margin={1}>
                    <Grid item xs={12}>
                        <div dangerouslySetInnerHTML={{ __html: props.text }} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}
